import { useEffect, useRef, useState } from 'react';

export default function useElementPageTop<
  T extends HTMLElement = HTMLElement,
>() {
  const ref = useRef<T | null>(null);
  const [top, setTop] = useState(0);

  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setTop(rect.top + scrollY);
    }
  }, []);

  return { ref, top };
}
